import { render, staticRenderFns } from "./EditCommunityPayment.vue?vue&type=template&id=62237d42&scoped=true"
import script from "./EditCommunityPayment.vue?vue&type=script&lang=js"
export * from "./EditCommunityPayment.vue?vue&type=script&lang=js"
import style0 from "./EditCommunityPayment.vue?vue&type=style&index=0&id=62237d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62237d42",
  null
  
)

export default component.exports